// Module
var code = "<div class=\"ui-grid-cell-contents\">{{row.entity.Created | date : \"shortDate\"}}</div>\n";
// Exports
module.exports = code;